/* eslint-disable react-hooks/rules-of-hooks */
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import React from "react";
import { showError, showToast } from "../constants/toasts";
import {
  useAddTagsMutation,
  useUpdateTagsMutation,
} from "../service/group&tags";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  getTagsApi: () => void;
  selectedTag: any;
  selectedTagId: string;
  groupId: string | undefined;
}

export default function AddTagsModal({
  open,
  onClose,
  setOpen,
  getTagsApi,
  selectedTag,
  selectedTagId,
  groupId,
}: AddCategoryModalProps) {
  const [addTags] = useAddTagsMutation();
  const [updateTags] = useUpdateTagsMutation();

  const [Status, setStatus] = React.useState("0");
  const handleChange2 = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [error, setError] = useState(false);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddTag = async () => {
    setError(true);
    if (name.trim() === "") {
      showError("Name is required");
      return;
    }

    setLoading(true);
    try {
      const body = {
        tagsName: name,
        groupId,
        ...(selectedTagId ? { tagsId: selectedTagId } : {}),
      };

      let response;
      if (selectedTagId) {
        response = await updateTags(body).unwrap();
      } else {
        response = await addTags(body).unwrap();
      }
      if (response?.status === 200) {
        setError(false);
        setOpen(false);
        showToast(
          selectedTagId ? "Tag updated successfully" : "Tag added successfully"
        );
        getTagsApi();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && selectedTag) {
      setName(selectedTag?.name || "");
    } else if (open && !selectedTag) {
      setName("");
    }
  }, [open, selectedTag]);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add Tags</h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </div>
          </div>
          <div className="control_group">
            <label htmlFor="tag">Tag Name</label>
            <TextField
              id="tag"
              placeholder="Enter Tag Name"
              fullWidth
              hiddenLabel
              value={name}
              inputProps={{ maxLength: 40 }}
              onChange={(e) => {
                if (e.target.value === " " || e.target.value === ".") {
                } else {
                  setName(e.target.value);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleAddTag();
                }
              }}
            />
            {error && name == "" ? (
              <h6 className="err_msg">Name is required</h6>
            ) : (
              ""
            )}
          </div>
          <div className="footer_btn_flex">
            <Button className="btn btn_primary" onClick={handleAddTag}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
